import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

const Video = (props) => {
  const {
    displayName = "Video",
  } = props;
  const videoRef = useRef("");
  useEffect(() => {
    videoRef.current.innerHTML = props.value.props.value
      .replace("<p>&lt;", '<iframe key="1" ')
      .replace("&gt;</p>", "/>")
      .replace("&gt;&lt;", "<")
      .replace(/&quot;/g, '"');
  }, []);
  let videoURL = props.value.props.value
    .split(" ")
    .find((el) => el.includes("src"));
  return (
    <React.Fragment>
      <div ref={videoRef} className={displayName}></div>
    </React.Fragment>
  );
};

export default Video;

Video.propTypes = {
  displayName: PropTypes.string,
};
